import { readStoreJourneyId } from '@/lib/storeLanding';

const STORE_JOURNEY_STORAGE_KEY = 'ac_store_journey';
const STORE_JOURNEY_TTL_MILLISECONDS = 30 * 60 * 1_000;

interface IStoredStoreJourney {
    journeyId: string;
    landedAtMilliseconds: number;
}

export const captureStoreJourney = (
    params: URLSearchParams,
    landedAtMilliseconds: number = Date.now()
): void => {
    const journeyId = readStoreJourneyId(params);
    if (!journeyId) {
        return;
    }

    try {
        sessionStorage.setItem(
            STORE_JOURNEY_STORAGE_KEY,
            JSON.stringify({ journeyId, landedAtMilliseconds })
        );
    } catch {
        return;
    }
};

export const getStoreJourneyContext = (
    nowMilliseconds: number = Date.now()
): Record<string, unknown> => {
    const journey = readStoredStoreJourney();
    if (!journey) return {};

    const storeDurationMilliseconds =
        nowMilliseconds - journey.landedAtMilliseconds;
    if (
        storeDurationMilliseconds < 0 ||
        storeDurationMilliseconds > STORE_JOURNEY_TTL_MILLISECONDS
    ) {
        removeStoredStoreJourney();
        return {};
    }

    return {
        journeyId: journey.journeyId,
        storeDurationMilliseconds,
    };
};

const readStoredStoreJourney = (): IStoredStoreJourney | undefined => {
    try {
        const value = sessionStorage.getItem(STORE_JOURNEY_STORAGE_KEY);
        if (!value) return undefined;
        const parsed = JSON.parse(value) as Partial<IStoredStoreJourney>;
        if (
            typeof parsed.journeyId !== 'string' ||
            typeof parsed.landedAtMilliseconds !== 'number'
        ) {
            return undefined;
        }
        return {
            journeyId: parsed.journeyId,
            landedAtMilliseconds: parsed.landedAtMilliseconds,
        };
    } catch {
        return undefined;
    }
};

const removeStoredStoreJourney = (): void => {
    try {
        sessionStorage.removeItem(STORE_JOURNEY_STORAGE_KEY);
    } catch {
        return;
    }
};
